// extracted by mini-css-extract-plugin
export default {"page":"ReferralsPage_page__CTjJP","title":"ReferralsPage_title__bctu5","toolbar":"ReferralsPage_toolbar__4+RMb","alignEnd":"ReferralsPage_alignEnd__kiKUQ"};